import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5effc6c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed w-full h-full z-30 inset-0 flex justify-center items-center"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"w-full h-full inset-0 bg-gray-700 opacity-25 absolute\" data-v-5effc6c0></div><div class=\"spinner\" data-v-5effc6c0><div class=\"bounce1\" data-v-5effc6c0></div><div class=\"bounce2\" data-v-5effc6c0></div><div class=\"bounce3\" data-v-5effc6c0></div></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isEnabledRoute && _ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
    : _createCommentVNode("", true)
}